<template>
    <div class="content-wrapper">

        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <greeting :user="user"></greeting>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="row" id="dragableCards">
                    <div class="col-md-6" data-id="1">
                        <div class="card">
                            <div class="card-header bg-danger text-white">
                                <div class="card-title">{{$t('dashboard.status')}}</div>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" @click="toggleStatus = !toggleStatus">
                                        <transition name="fade">
                                            <i class="fas fa-minus" v-if="toggleStatus"></i>
                                            <i class="fas fa-plus" v-else></i>
                                        </transition>
                                    </button>
                                </div>
                            </div>
                            <transition name="fade">
                                <div class="card-body" v-show="toggleStatus">
                                    <div class="chartjs-size-monitor">
                                        <div class="chartjs-size-monitor-expand">
                                            <div></div>
                                        </div>
                                        <div class="chartjs-size-monitor-shrink">
                                            <div></div>
                                        </div>
                                    </div>
                                    <canvas id="statusChart" style="height: 400px; min-height: 400px; max-height: 400px; width: 100% !important; display: block;" class="chartjs-render-monitor"></canvas>
                                </div>
                            </transition>
                        </div>
                    </div>

                    <div class="col-md-6" data-id="2">
                        <div class="card">
                            <div class="card-header bg-success text-white">
                                <div class="card-title">{{$t('dashboard.partner')}}</div>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" @click="togglePartner = !togglePartner">
                                        <transition name="fade">
                                            <i class="fas fa-minus" v-if="togglePartner"></i>
                                            <i class="fas fa-plus" v-else></i>
                                        </transition>
                                    </button>
                                </div>
                            </div>
                            <transition name="fade">
                                <div class="card-body" v-show="togglePartner">
                                    <div class="chartjs-size-monitor">
                                        <div class="chartjs-size-monitor-expand">
                                            <div></div>
                                        </div>
                                        <div class="chartjs-size-monitor-shrink">
                                            <div></div>
                                        </div>
                                    </div>
                                    <canvas id="partnerChart" style="height: 400px; min-height: 400px; max-height: 400px; width: 100% !important; display: block; font-size:inherit" class="chartjs-render-monitor"></canvas>
                                </div>
                            </transition>
                        </div>
                    </div>

                    <div class="col-md-6" data-id="3">
                        <div class="card">
                            <div class="card-header bg-info text-white">
                                <h3 class="card-title">{{$t('dashboard.birthday')}}</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool"
                                        @click="toggleBirthday = !toggleBirthday">
                                        <transition name="fade">
                                            <i class="fas fa-minus" v-if="toggleBirthday"></i>
                                            <i class="fas fa-plus" v-else></i>
                                        </transition>
                                    </button>
                                </div>
                            </div>
                            <transition name="fade">
                                <div v-show="toggleBirthday">
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover" v-if="birthdayList.length">
                                            <thead>
                                                <tr>
                                                    <th>{{$t('dashboard.name')}}</th>
                                                    <th>{{$t('dashboard.number')}}</th>
                                                    <th>{{$t('dashboard.dob')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(student, index) in birthdayList" v-bind:key="index">
                                                    <td>{{student.FirstName}} {{student.LastName}}</td>
                                                    <td>{{student.StudentNumber}}</td>
                                                    <td>{{student.BirthDate | formatDate(dateFormat)}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="p-3 m-0" v-else>{{$t('dashboard.noBirthday')}}</p>
                                    </div>
                                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                                        @paginate="paginate()" onlyDirectional="true">
                                    </pagination>
                                </div>
                            </transition>
                        </div>
                    </div>

                    <div class="col-md-6" data-id="4" v-show="permissions.viewAnnouncements">
                        <div class="card">
                            <div class="card-header bg-dark text-light">
                                <h3 class="card-title">{{$t('dashboard.news')}}</h3>
                                <div class="card-tools">
                                    <b-button v-b-modal.createNewsModal variant="secondary" class="btn-tool btn-custom"
                                        v-if="permissions.createAnnouncements">{{$t('button.create')}}</b-button>
                                    <button type="button" class="btn btn-tool" @click="toggleNews = !toggleNews">
                                        <transition name="fade">
                                            <i class="fas fa-minus" v-if="toggleNews"></i>
                                            <i class="fas fa-plus" v-else></i>
                                        </transition>
                                    </button>
                                </div>
                            </div>
                            <transition name="fade">
                                <div v-show="toggleNews">
                                    <div class="card-body p-0">
                                        <table class="table" v-if="announcements.length">
                                            <tbody>
                                                <tr v-for="(news, index) in announcements" :key="index">
                                                    <td>
                                                        <div class="justify-content-between">
                                                            <div class="col-sm-12 row">
                                                                <div class="text-primary c-pointer col-sm-10" @click="showNews(news);"
                                                                    v-html="` ${$options.filters.formatDate(news.date, dateFormat)} - ${getTime(news.date)} |  ${news.user.name} | ${$options.filters.strip(news.title)}`">
                                                                </div>
                                                                <div class="col-sm-2 text-right">
                                                                    <button class="btn btn-info btn-sm"
                                                                        v-if="permissions.editAnnouncements || news.user_id == user.id"
                                                                        @click="editNews(news)">
                                                                        <span class="fa fa-edit"></span>
                                                                    </button>
                                                                    <button class="btn btn-danger btn-sm"
                                                                        v-if="permissions.deleteAnnouncements || news.user_id == user.id"
                                                                        @click="deleteNews(index)">
                                                                        <span class="fa fa-trash"></span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-12 row">
                                                                <span style="margin-left:8px;" v-if="news.AnnouncementOnDashboard" v-html="news.body"></span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="p-3 m-0" v-else>{{$t('dashboard.noNews')}}</p>
                                    </div>
                                    <pagination v-if="newsPagination.last_page > 1" :pagination="newsPagination"
                                        :offset="5" @paginate="paginate('news')" onlyDirectional="true">
                                    </pagination>
                                </div>
                            </transition>
                        </div>
                    </div>

                    <div class="col-md-6" data-id="5" v-show="showAbsenceList">
                        <div class="card">
                            <div class="card-header bg-warning">
                                <h3 class="card-title">{{$t('dashboard.staffAbsence')}}</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" @click="toggleAbsence = !toggleAbsence">
                                        <transition name="fade">
                                            <i class="fas fa-minus" v-if="toggleAbsence"></i>
                                            <i class="fas fa-plus" v-else></i>
                                        </transition>
                                    </button>
                                </div>
                            </div>
                            <transition name="fade">
                                <div v-show="toggleAbsence">
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover" v-if="absences.length">
                                            <thead>
                                                <tr>
                                                    <th>{{$t('dashboard.name')}}</th>
                                                    <th>{{$t('dashboard.duration')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(absence, index) in absences" :key="index">
                                                    <td>{{absence.staff.FirstName}} {{absence.staff.LastName}}</td>
                                                    <td>
                                                        {{$t('dashboard.durationValue', {
                                                        from: $options.filters.formatDate(absence.from, dateFormat),
                                                        to: $options.filters.formatDate(absence.to, dateFormat),
                                                        days: absence.days
                                                    })}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p class="p-3 m-0" v-else>{{$t('dashboard.noAbsence')}}</p>
                                    </div>
                                    <pagination v-if="absencePagination.last_page > 1" :pagination="absencePagination"
                                        :offset="5" @paginate="paginate('absence')" onlyDirectional="true">
                                    </pagination>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>

                <b-modal id="viewNewsModal" size="lg" v-if="permissions.viewAnnouncements">
                    <template v-slot:modal-header>
                        <h5>{{$t('dashboard.news')}}<br>
                        </h5>
                    </template>

                    <div class="d-flex justify-content-between">
                        <p><b>{{newsDisplay.title}}</b></p>
                        <p v-if="newsDisplay.expiry">{{newsDisplay.expiry | formatDate(dateFormat)}}</p>
                    </div>

                    <div v-html="newsDisplay.body"></div>

                    <p class="border-top-3 col-12 pt-2" style="border-top:1px solid">
                        {{$t('dashboard.modifiedDate')}}
                        {{newsDisplay.date  | formatDate(dateFormat)}} at {{getTime(newsDisplay.date)}}<br>
                        {{$t('dashboard.createdBy')}} {{newsDisplay.user.name}}
                    </p>

                    <div class="form-group">
                        <a href="#" @click.prevent="newNews" class="text-dark">
                            <i class="fas fa-plus text-success"></i>
                            {{$t('dashboard.newNews')}}</a>
                    </div>

                    <template v-slot:modal-footer="{ ok }">
                        <b-button @click="ok()">
                            {{$t('button.close')}}
                        </b-button>
                    </template>
                </b-modal>

                <b-modal id="createNewsModal" size="lg" v-if="permissions.createAnnouncements"
                    :title="$t('dashboard.createNews')">
                    <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                    <div class="form-group">
                        <label>{{$t('dashboard.title')}}<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model.trim="$v.announcement.title.$model"
                            :class="{ 'is-invalid': $v.announcement.title.$error }">
                        <div class="invalid-feedback" v-if="!$v.announcement.title.required">
                            {{$t('form.validation.required')}}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{$t('dashboard.announcement')}}</label>
                        <textarea class="textarea" placeholder="Place some text here"
                            style="width: 100%; height: 250px; font-size: 14px; line-height: 18px; border: 1px solid #dddddd; padding: 10px;"></textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <input type="checkbox" v-model="announcement.AnnouncementOnDashboard">
                            {{$t('dashboard.announcementOnDashboard')}}
                        </label>
                    </div>
                    <div class="form-group">
                        <label>{{$t('dashboard.date')}}<span class="text-danger">*</span></label>
                        <date-picker :lang="lang" class="date-picker" v-model="announcement.date" valueType="format"
                            type="datetime" :format="datetimeFormat" :time-picker-options="timeOptions"
                            :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                        </date-picker>
                        <div class="invalid-feedback d-block" v-if="invalidDate">
                            {{$t('form.validation.required')}}</div>
                    </div>
                    <div class="form-group">
                        <label>{{$t('dashboard.expire')}}</label>
                        <date-picker :lang="lang" class="date-picker" v-model="announcement.expiry" valueType="format"
                            :format="dateFormat"
                            :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                        </date-picker>
                    </div>

                    <template v-slot:modal-footer="{ ok }">
                        <b-button @click="ok()">
                            {{$t('button.close')}}
                        </b-button>
                        <b-button variant="primary" @click="createAnnouncement($event)">
                            {{$t('button.save')}}
                        </b-button>
                    </template>
                </b-modal>

                <b-modal id="editNewsModal" size="lg" :title="$t('dashboard.editNews')">
                    <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                    <div class="form-group">
                        <label>{{$t('dashboard.title')}}</label>
                        <input type="text" class="form-control" v-model="newsDisplay.title">
                    </div>
                    <div class="form-group">
                        <label>{{$t('dashboard.announcement')}}</label>
                        <textarea class="textarea" id="editSummernote" placeholder="Place some text here"
                            style="width: 100%; height: 250px; font-size: 14px; line-height: 18px; border: 1px solid #dddddd; padding: 10px;"></textarea>
                    </div>
                    <div class="form-group">
                        <label>
                            <input type="checkbox" :checked="announcements.some(obj => obj.id === newsDisplay.id && newsDisplay.AnnouncementOnDashboard === 1
                                )" v-model="newsDisplay.AnnouncementOnDashboard">
                            {{$t('dashboard.announcementOnDashboard')}}
                        </label>
                    </div>
                    <!-- <div class="form-group">
                        <label>{{$t('dashboard.date')}}</label>
                        <input type="date" class="form-control" v-model="newsDisplay.date">
                    </div>
                    <div class="form-group">
                        <label>{{$t('dashboard.expire')}}</label>
                        <input type="date" class="form-control" v-model="newsDisplay.expiry">
                    </div> -->

                    <div class="form-group">
                        <label>{{$t('dashboard.date')}}<span class="text-danger">*</span></label>
                        <date-picker :lang="lang" class="date-picker" v-model="newsDisplay.date" valueType="format"
                             type="datetime" :format="datetimeFormat" :time-picker-options="timeOptions" :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                        </date-picker>
                        <div class="invalid-feedback d-block" v-if="invalidDate">
                            {{$t('form.validation.required')}}</div>
                    </div>
                    <div class="form-group">
                        <label>{{$t('dashboard.expire')}}</label>
                        <date-picker :lang="lang" class="date-picker" v-model="newsDisplay.expiry" valueType="format"
                              :format="dateFormat" :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                        </date-picker>
                    </div>

                    <template v-slot:modal-footer="{ ok }">
                        <b-button @click="ok()">
                            {{$t('button.close')}}
                        </b-button>
                        <b-button variant="primary" @click="updateAnnouncement($event)">
                            {{$t('button.save')}}
                        </b-button>
                    </template>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import greeting from '../../components/Greeting';
    import Chart from 'chart.js';
    import Sortable from 'sortablejs';
    import {
        required,
        minLength,
        maxLength,
        decimal,
        alpha
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions', 'user', 'dateFormat','datetimeFormat'],
        components: {
            greeting
        },

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                invalidDate: false,

                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },

                toggleStatus: true,
                togglePartner: true,
                toggleBirthday: true,
                toggleNews: true,
                toggleAbsence: true,

                announcement: {
                    title: '',
                    body: '',
                    AnnouncementOnDashboard: 1,
                    expiry: '',
                    date: moment().format(this.datetimeFormat)
                },

                newsDisplay: {
                    user: {}
                },

                birthdayList: [],
                programs: [],
                announcements: [],
                absences: [],

                request_source: '',

                pagination: {
                    current_page: 1
                },

                newsPagination: {
                    current_page: 1
                },

                absencePagination: {
                    current_page: 1
                },


                timeOptions: {
                    start: '00:00',
                    step: '00:10',
                    end: '23:00',
                    format: 'HH:mm'
                },

                alert: false,
                alertMessage: '',
                alertClass: '',

                partnerData: {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: ['#f56954', '#00a65a', '#f39c12', '#00c0ef', '#3c8dbc', '#d2d6de',
                            '#34495E', '#EB984E', '#52BE80', '#8E44AD', '#CD6155', '#1ABC9C'
                        ],
                    }]
                },

                statusData: {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: ['#f56954', '#00a65a', '#f39c12', '#00c0ef', '#3c8dbc', '#d2d6de',
                            '#532e6b', '#523f18'
                        ],
                    }]
                }
            }
        },

        validations: {
            announcement: {
                title: {
                    required,
                },
                date: {
                    required,
                }
            }
        },

        mounted() {
            this.getCardsConfig();
            this.initDragableCards();

            this.getAnnouncements();
            this.getStudents();
            this.getStatistics();
            this.getAbsences();

            this.initSummernote();
        },

        watch: {
            toggleStatus() {
                this.setCardsConfig();
            },
            togglePartner() {
                this.setCardsConfig();
            },
            toggleBirthday() {
                this.setCardsConfig();
            },
            toggleNews() {
                this.setCardsConfig();
            },
            toggleAbsence() {
                this.setCardsConfig();
            }
        },

        computed: {
            showAbsenceList() {
                if (!this.user.roles) return false;

                let role = this.user.roles.find(role => role.slug == 'admin')

                if (role || this.user.partner_id == 1) {
                    return true
                }

                return false
            }
        },

        methods: {

            getTime(date){
                return moment(date).format('HH:mm');
            },
            initDragableCards() {
                let dragableCards = document.getElementById('dragableCards');

                let sortable = Sortable.create(dragableCards, {
                    handle: '.card-header',
                    animation: 150,
                    group: "dragable-card",
                    store: {
                        /**
                         * Get the order of elements. Called once during initialization.
                         * @param   {Sortable}  sortable
                         * @returns {Array}
                         */
                        get: function (sortable) {
                            var order = localStorage.getItem(sortable.options.group.name);
                            return order ? order.split('|') : [];
                        },

                        /**
                         * Save the order of elements. Called onEnd (when the item is dropped).
                         * @param {Sortable}  sortable
                         */
                        set: function (sortable) {
                            var order = sortable.toArray();
                            localStorage.setItem(sortable.options.group.name, order.join('|'));
                        }
                    }
                });
            },

            getCardsConfig() {
                let cardStatus = JSON.parse(localStorage.getItem('cardStatus'));

                if (cardStatus) {
                    this.toggleStatus = cardStatus.toggleStatus;
                    this.togglePartner = cardStatus.togglePartner;
                    this.toggleBirthday = cardStatus.toggleBirthday;
                    this.toggleNews = cardStatus.toggleNews;
                    this.toggleAbsence = cardStatus.toggleAbsence;
                }

            },

            setCardsConfig() {
                localStorage.setItem('cardStatus', JSON.stringify({
                    toggleStatus: this.toggleStatus,
                    togglePartner: this.togglePartner,
                    toggleBirthday: this.toggleBirthday,
                    toggleNews: this.toggleNews,
                    toggleAbsence: this.toggleAbsence
                }));
            },

            initSummernote() {
                let self = this;
                this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
                    self.clearAlert();

                    setTimeout(() => {
                        $('.textarea').summernote({
                            dialogsInBody: true,
                            height: 250
                        });

                        $('.textarea').summernote('reset');
                        $('.textarea').summernote('fontName', 'Verdana');

                        $('.textarea').on('summernote.change', function (we, contents, $editable) {
                            self.announcement.body = contents;
                        });

                        $('#editSummernote').summernote('code', self.newsDisplay.body);

                        $('#editSummernote').on('summernote.change', function (we, contents,
                            $editable) {
                            self.newsDisplay.body = contents;
                        });
                    }, 500);
                });
            },

            showNews(news) {               
                this.newsDisplay = {
                    ...news
                };
                this.$bvModal.show('viewNewsModal');
            },

            editNews(news) {
                this.clearAlert();

                this.newsDisplay = {
                    ...news
                };
                this.newsDisplay.date = moment(this.newsDisplay.date).format(this.datetimeFormat);
                if (this.newsDisplay.expiry) {
                    this.newsDisplay.expiry = moment(this.newsDisplay.expiry).format(this.dateFormat);
                }

                this.$bvModal.show('editNewsModal');
            },

            /**
             * Delete annoucement
             */
            deleteNews(index) {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    this.isLoading = true;
                    axios
                        .delete("/api/announcements/" + this.announcements[index].id)
                        .then(response => {
                            this.isLoading = false;
                            this.announcements.splice(index, 1);
                            this.showAlert(response.data.message);
                            // this.getAnnouncements();
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            newNews() {
                this.clearAlert();
                this.$bvModal.hide('viewNewsModal');
                this.$bvModal.show('createNewsModal');
            },

            getAnnouncements() {
                axios
                    .get('/api/announcements?page=' + this.newsPagination.current_page)
                    .then(response => {

                        this.announcements = [];
                        response.data.data.data.forEach((dt)=>{
                            if(dt.expiry == null || moment(dt.expiry) >= moment())
                            {
                                this.announcements.push(dt);
                            }
                        });

                        this.newsPagination = response.data.pagination;
                    }, error => {
                        console.log('error');
                    });
            },

            createAnnouncement(event) {
                this.$v.$touch();

                this.invalidDate = this.announcement.date == null ? true : false;

                if (this.$v.$invalid) return;

                event.target.disabled = true;

                axios
                    .post('/api/announcements', this.announcement)
                    .then(response => {
                        if (response.data.error) {
                            this.showAlert(response.data.message, 'danger');
                            event.target.disabled = false;
                        }

                        if (response.data.success) {
                            this.announcement = {
                                title: '',
                                body: '',
                                expiry: null,
                                date: moment().format(this.datetimeFormat)
                            };

                            this.$v.announcement.$reset();
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                event.target.disabled = false;
                                this.clearAlert();
                                this.$bvModal.hide('createNewsModal');
                                this.getAnnouncements();
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        console.log('error');
                        event.target.disabled = false;
                    });
            },

            updateAnnouncement(event) {
                event.target.disabled = true;

                axios
                    .put(`/api/announcements/${this.newsDisplay.id}`, this.newsDisplay)
                    .then(response => {
                        if (response.data.error) {
                            this.showAlert(response.data.message, 'danger');
                            event.target.disabled = false;
                        }

                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                event.target.disabled = false;
                                this.clearAlert();
                                this.$bvModal.hide('editNewsModal');
                                this.getAnnouncements();
                            }, 1000);
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    });
            },

            drawGraphs() {
                // status graph
                var statusChartCanvas = $('#statusChart').get(0).getContext('2d')
                var statusChart = new Chart(statusChartCanvas, {
                    type: 'doughnut',
                    data: this.statusData,
                    options: {
                        legend: {
                            position: 'bottom',
                            labels: {
                                fontSize: 20
                            }
                        },
                        tooltips: {
                            bodyFontSize: 20
                        },
                        maintainAspectRatio: false,
                        responsive: true,
                    }
                });

                // partners graph
                var partnerChartCanvas = $('#partnerChart').get(0).getContext('2d')
                var partnerChart = new Chart(partnerChartCanvas, {
                    type: 'pie',
                    data: this.partnerData,
                    options: {
                        legend: {
                            position: 'bottom',
                            labels: {
                                fontSize: 20
                            }
                        },
                        tooltips: {
                            bodyFontSize: 20
                        },
                        maintainAspectRatio: false,
                        responsive: true,
                    }
                });

            },

            async getStatistics() {
                let response = await axios.get('/api/statistics');

                this.statusData.labels = [];
                this.statusData.datasets[0].data = [];
                this.partnerData.labels = [];
                this.partnerData.datasets[0].data = [];

                response.data.status.forEach(status => {
                    this.statusData.labels.push(status.StatusName);
                    this.statusData.datasets[0].data.push(status.students_count);
                });

                response.data.partners.forEach(partner => {
                    this.partnerData.labels.push(partner.PartnerCode);
                    this.partnerData.datasets[0].data.push(partner.students_count);
                });

                this.drawGraphs();
            },

            getAbsences() {
                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                axios
                    .get('/api/absences/dashboard?home=1&page=' + this.absencePagination.current_page, {
                        cancelToken: this.request_source.token,
                        params: {startWithIn : 14},
                    })
                    .then(response => {
                        this.absences = response.data.data.data;
                        this.absencePagination = response.data.pagination;
                    })
                    .catch(error => {
                        // console.log('error');
                    });
            },

            getDays(from, to) {
                return new moment(to).dayOfYear() - new moment(from).dayOfYear() + 1;
            },

            /**
             * Apply paginate
             */
            paginate(method = null) {

                if (method === 'news') {
                    this.getAnnouncements();
                    return;
                }

                if (method === 'absence') {
                    this.getAbsences();
                    return;
                }

                this.getStudents();
            },

            // Get Birthday List
            getStudents() {
                axios
                    .get("/api/students/birthday?page=" + this.pagination.current_page)
                    .then(response => {
                        this.birthdayList = response.data.data.data;
                        this.pagination = response.data.pagination;
                    });
            },

            /**
             * Show alert
             */
            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            /**
             * Clear Alert
             */
            clearAlert() {
                this.alertClass = '';
                this.alertMessage = '';
                this.alert = false;
            },

        }
    }

</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .card-header:hover {
        cursor: move;
    }

    .date-picker {
        display: block;
        width: 100%;
    }

    #createNewsModal___BV_modal_outer_,
    #editNewsModal___BV_modal_outer_ {
        z-index: 999 !important;
    }

</style>
